import "./glossary-page.scss";

